/** تبدیل تاریخ شمسی/میلادی (الگوریتم jalaali-js) و قالب‌بندی فارسی */
const breaks = [-61, 9, 38, 199, 426, 686, 756, 818, 1111, 1181, 1210, 1635, 2060, 2097, 2192, 2262, 2324, 2394, 2456, 3178];
const div = (a: number, b: number) => ~~(a / b);
const mod = (a: number, b: number) => a - ~~(a / b) * b;

function jalCal(jy: number, withoutLeap?: boolean) {
  const bl = breaks.length; const gy = jy + 621; let leapJ = -14; let jp = breaks[0]; let jm = 0; let jump = 0;
  for (let i = 1; i < bl; i++) { jm = breaks[i]; jump = jm - jp; if (jy < jm) break; leapJ += div(jump, 33) * 8 + div(mod(jump, 33), 4); jp = jm; }
  let n = jy - jp;
  leapJ += div(n, 33) * 8 + div(mod(n, 33) + 3, 4);
  if (mod(jump, 33) === 4 && jump - n === 4) leapJ += 1;
  const leapG = div(gy, 4) - div((div(gy, 100) + 1) * 3, 4) - 150;
  const march = 20 + leapJ - leapG;
  if (withoutLeap) return { gy, march, leap: 0 };
  if (jump - n < 6) n = n - jump + div(jump + 4, 33) * 33;
  let leap = mod(mod(n + 1, 33) - 1, 4); if (leap === -1) leap = 4;
  return { leap, gy, march };
}
function g2d(gy: number, gm: number, gd: number) {
  let d = div((gy + div(gm - 8, 6) + 100100) * 1461, 4) + div(153 * mod(gm + 9, 12) + 2, 5) + gd - 34840408;
  d = d - div(div(gy + 100100 + div(gm - 8, 6), 100) * 3, 4) + 752; return d;
}
function d2g(jdn: number) {
  let j = 4 * jdn + 139361631; j = j + div(div(4 * jdn + 183187720, 146097) * 3, 4) * 4 - 3908;
  const i = div(mod(j, 1461), 4) * 5 + 308; const gd = div(mod(i, 153), 5) + 1; const gm = mod(div(i, 153), 12) + 1; const gy = div(j, 1461) - 100100 + div(8 - gm, 6);
  return { gy, gm, gd };
}
function j2d(jy: number, jm: number, jd: number) { const r = jalCal(jy, true); return g2d(r.gy, 3, r.march) + (jm - 1) * 31 - div(jm, 7) * (jm - 7) + jd - 1; }
function d2j(jdn: number) {
  const gy = d2g(jdn).gy; let jy = gy - 621; const r = jalCal(jy); const jdn1f = g2d(gy, 3, r.march); let k = jdn - jdn1f; let jm: number, jd: number;
  if (k >= 0) { if (k <= 185) { jm = 1 + div(k, 31); jd = mod(k, 31) + 1; return { jy, jm, jd }; } k -= 186; }
  else { jy -= 1; k += 179; if (r.leap === 1) k += 1; }
  jm = 7 + div(k, 30); jd = mod(k, 30) + 1; return { jy, jm, jd };
}
export const toJalali = (gy: number, gm: number, gd: number) => d2j(g2d(gy, gm, gd));
export const toGregorian = (jy: number, jm: number, jd: number) => d2g(j2d(jy, jm, jd));
export const isLeapJalali = (jy: number) => jalCal(jy).leap === 0;
export const jalaliMonthLength = (jy: number, jm: number) => (jm <= 6 ? 31 : jm <= 11 ? 30 : isLeapJalali(jy) ? 30 : 29);

export const JALALI_MONTHS = ["حمل", "ثور", "جوزا", "سرطان", "اسد", "سنبله", "میزان", "عقرب", "قوس", "جدی", "دلو", "حوت"];
export const WEEKDAYS_SHORT = ["ش", "ی", "د", "س", "چ", "پ", "ج"];
export const WEEKDAYS_LONG = ["شنبه", "یکشنبه", "دوشنبه", "سه‌شنبه", "چهارشنبه", "پنجشنبه", "جمعه"];

export const fa = (v: string | number) => String(v).replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[+d]);
const p2 = (n: number) => String(n).padStart(2, "0");

export const jalaliOf = (d: Date) => toJalali(d.getFullYear(), d.getMonth() + 1, d.getDate());
export const jalaliToDate = (jy: number, jm: number, jd: number, h = 0, mi = 0) => { const g = toGregorian(jy, jm, jd); return new Date(g.gy, g.gm - 1, g.gd, h, mi, 0, 0); };
/** ۰=شنبه … ۶=جمعه */
export const weekdayIndex = (d: Date) => (d.getDay() + 1) % 7;

export const fmtTime = (iso?: string | null) => { if (!iso) return ""; const d = new Date(iso); return fa(`${p2(d.getHours())}:${p2(d.getMinutes())}`); };
export const fmtDate = (iso?: string | null, withYear = true) => { if (!iso) return ""; const j = jalaliOf(new Date(iso)); return fa(`${j.jd} ${JALALI_MONTHS[j.jm - 1]}${withYear ? " " + j.jy : ""}`); };
export const fmtDateTime = (iso?: string | null) => (iso ? `${fmtDate(iso)}، ${fmtTime(iso)}` : "");
export const dayKey = (iso: string) => { const d = new Date(iso); return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`; };
export const sameDay = (a: Date, b: Date) => a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

/** «امروز» / «دیروز» / تاریخ کامل با نام روز */
export function dayLabel(iso: string) {
  const d = new Date(iso); const now = new Date(); const y = new Date(); y.setDate(now.getDate() - 1);
  if (sameDay(d, now)) return "امروز"; if (sameDay(d, y)) return "دیروز";
  return `${WEEKDAYS_LONG[weekdayIndex(d)]} ${fmtDate(iso)}`;
}
/** نمایش فشرده برای لیست گفتگو */
export function listTime(iso?: string | null) {
  if (!iso) return ""; const d = new Date(iso); const now = new Date(); const y = new Date(); y.setDate(now.getDate() - 1);
  if (sameDay(d, now)) return fmtTime(iso); if (sameDay(d, y)) return "دیروز";
  return fmtDate(iso, false);
}
export function lastSeenText(iso?: string | null) {
  if (!iso) return "مدت‌ها پیش";
  const diff = Date.now() - new Date(iso).getTime();
  if (diff < 90e3) return "لحظاتی پیش";
  if (diff < 3600e3) return `${fa(Math.round(diff / 60e3))} دقیقه پیش`;
  const d = new Date(iso);
  return sameDay(d, new Date()) ? `امروز ${fmtTime(iso)}` : `${fmtDate(iso)} ${fmtTime(iso)}`;
}
export function relativeDue(iso: string) {
  const diff = new Date(iso).getTime() - Date.now(); const abs = Math.abs(diff); const m = Math.round(abs / 60e3);
  const t = m < 60 ? `${fa(m)} دقیقه` : m < 1440 ? `${fa(Math.round(m / 60))} ساعت` : `${fa(Math.round(m / 1440))} روز`;
  return diff >= 0 ? `${t} مانده` : `${t} تأخیر`;
}
export const fmtDuration = (s?: number | null) => { s = Math.max(0, Math.round(s || 0)); const h = div(s, 3600); const m = div(s % 3600, 60); const ss = s % 60; return fa(h ? `${h}:${p2(m)}:${p2(ss)}` : `${p2(m)}:${p2(ss)}`); };
export const fmtSize = (b?: number | null) => { if (!b) return ""; const u = ["بایت", "کیلوبایت", "مگابایت", "گیگابایت"]; let i = 0; let n = b; while (n >= 1024 && i < 3) { n /= 1024; i++; } return `${fa(n >= 10 || i === 0 ? Math.round(n) : n.toFixed(1))} ${u[i]}`; };
